import React from "react";
import { Col, Modal, Nav, Row, Tab } from "react-bootstrap";
import { DocumentTab } from "./sections/documents";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import Document from "./sections/documents/Document";
import { shallowEqual, useSelector } from "react-redux";
import { permissionAllow } from "../../../../util/Helpers";
import { PermissionType, Permissions } from "../../../../util/Permissions";
import { useGetDocumentsQuery } from "../../../../../redux/apiSlice";
import PendingDocumentModalSkeleton from "./PendingDocumentModalSkeleton";

export function PendingDocumentModal({ showPendingDocumentModal, onHide, details }) {
    const adminUser = useSelector(({ auth }) => (auth.user), shallowEqual);
    const { isLoading, data } = useGetDocumentsQuery(details);

    return (
        <Modal
            show={showPendingDocumentModal}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header >
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/files/jpg.svg")}
                        />
                    </span>
                    Document Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                style={{ height: "calc(100vh - 220px)" }}
            >
                {
                    isLoading
                        ? <PendingDocumentModalSkeleton />
                        : <Tab.Container id="left-tabs-example" defaultActiveKey={details?.documentId} className={"h-100"}>
                            <Row className={"h-100"}>
                                <Col
                                    sm={4}
                                    className={"d-flex flex-column border-right h-100 overflow-auto"}
                                >
                                    <Nav>
                                        {data?.docs.map(({ documentId, type, status, document }) => (
                                            <DocumentTab
                                                key={documentId}
                                                dataKey={documentId}
                                                status={status}
                                                src={document}
                                                title={type.replaceAll("_", " ").toLowerCase()}
                                            />
                                        ))}
                                    </Nav>
                                </Col>
                                <Col sm={8} className={"h-100 overflow-auto"}>
                                    <Tab.Content className={"h-100"}>
                                        {data?.docs.map((doc) => (
                                            <Tab.Pane key={doc.documentId} eventKey={doc.documentId} className={"h-100"}>
                                                <Document
                                                    checkResult={data.cip}
                                                    initialValues={doc}
                                                    isEditable={permissionAllow(adminUser, Permissions.PENDING_KYC, PermissionType.UPDATE)}
                                                />
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                }
            </Modal.Body>
        </Modal>
    )
}